var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_setup.homeUrl,"title":_setup.app.appTitle}},[_c('img',{staticClass:"af-app-logo",attrs:{"src":_setup.app.appIcon,"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }